module.exports = __webpack_public_path__ + "img/1007_sp.a707495e.gif";